export const BRAND_COLOR = "#56225f";
